// extracted by mini-css-extract-plugin
module.exports = {"drawerContainer":"SlideDrawer_drawerContainer__QGSsl","drawerOpen":"SlideDrawer_drawerOpen__3IdXN"};